import { render, staticRenderFns } from "./UserProductsOrder.vue?vue&type=template&id=6e0e228a&"
import script from "./UserProductsOrder.vue?vue&type=script&lang=js&"
export * from "./UserProductsOrder.vue?vue&type=script&lang=js&"
import style0 from "./UserProductsOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports